// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".good--text[data-v-84f9eff8] {\n  color: #139E06;\n}\n.lag-text[data-v-84f9eff8] {\n  font-size: 0.625rem;\n}\n.status-wrapper[data-v-84f9eff8] {\n  position: relative;\n}", ""]);
// Exports
module.exports = exports;
